<template>
    <div class="controls">
      <label for="server">Server:</label>
      <select v-model="baseApiUrl" @change="refreshTiles(true)">
        <option value="https://weather5.visualcrossing.com">Weather5</option>
        <option value="http://localhost:8080">Localhost</option>
      </select>
    
      <label for="model">Model:</label>
      <select v-model="selectedModel" @change="onModelChange">
        <option v-for="model in Object.keys(modelOptions)" :key="model" :value="model">{{ model }}</option>
      </select>
    
      <label for="element">Element:</label>
      <select v-model="selectedElement" @change="refreshTiles()">
        <option v-for="element in availableElements" :key="element" :value="element">{{ element }}</option>
      </select>
    
      <label for="unitGroup">Unit Group:</label>
      <select v-model="unitGroup" @change="refreshTiles()">
        <option value="us">US</option>
        <option value="metric">Metric</option>
      </select>
      <label for="tileFormat">Tile format:</label>
      <select v-model="tileFormat" @change="refreshTiles(true)">
        <option value="png">PNG</option>
        <option value="webp">WebP</option>
      </select>
      <label for="timeSkip">Time skip:</label>
      <select id="timeSkip" v-model.number="timeSkip" @change="onTimeSkipOverride">
        <option :value="2">2 min</option>
        <option :value="5">5 min</option>
        <option :value="10">10 min</option>
        <option :value="15">15 min</option>
        <option :value="60">60 min</option>
      </select>
        <label for="speed">Playback Speed:</label>
        <input type="range" id="speed" v-model="playbackSpeed" min="0.5" max="2" step="0.1" @input="adjustPlaybackSpeed">
        <span>{{ playbackSpeed }}x</span>
      
     
    
      <label for="opacity">Opacity:</label>
      <input type="range" v-model="layerOpacity" min="0" max="1" step="0.1" @input="updateLayerOpacity" />
    
      <button @click="toggleMoviePlay">{{ isPlaying ? 'Stop' : 'Play' }}</button>
      <button @click="resetToInitialTime">Reset</button>
    
      <button @click="decrementTime">Back</button>
      <button @click="incrementTime">Forward</button>
    
      <label for="toggleMapSize">Full Screen:</label>
      <input type="checkbox" v-model="isFullScreenMap" @change="updateMapSize" />
    </div>
    <div class="info">
    <div>
      <label for="opacity">Center:</label>
      <code>{{ viewInfo.centerPair }}</code>
      <button @click="copyCenterToClipboard" style="margin-left: 6px;">Copy</button>
    </div>
    <div><strong>Zoom:</strong> {{ viewInfo.zoom }}</div>
   <!--<div><strong>Time:</strong> {{ formattedTime }}</div>
    <div><strong>Layer:</strong> {{ selectedModel }} / {{ selectedElement }} ({{ unitGroup }}, {{ tileFormat }})</div>--> 
  </div>
    <div id="map" :style="mapStyle">
      <div class="time-overlay" @click="showDateTimePicker = true" style="cursor:pointer;">
        {{ formattedTime }}
      </div>
      <div v-if="showDateTimePicker" class="datetime-picker-overlay">
        <input
          type="datetime-local"
          :value="dateTimeLocalValue"
          @change="onDateTimeInput"
        />
        <button @click="showDateTimePicker = false">Close</button>
      </div>
    </div>
</template>
  
  <script>
  import L from "leaflet";
  import "leaflet/dist/leaflet.css";
  
  
export default {
  name: "LeafletMap",
  data() {
    return {
      map: null,
      tileLayer: null,
      previousLayer: null,
      isZooming: false,
      modelOptions: {
         default: { 
          elements: ["precipcomposite","preciprate", "preciptype", "hailsize", "temp", "cloudcover", "sealevelpressure","windspeed", "winddir", "wind","cloudtopheight","cloudtoptemp","cloudopticaldepth","cloudphase","abi_rad_c02","abi_rad_c07"], 
          timeSkip: 2,
          timeSkipOverride: false,
          loopWindow: {
            startOffset: -120, // 120 minutes before current time
            endOffset: 120    // 120 minutes after current time
          }
         },
         mrms_2min_location_2:{ 
          elements:["precipcomposite","preciprate", "preciptype", "hailsize", "reflectivity"], 
          timeSkip: 2,
          timeSkipOverride: false,
          loopWindow: {
            startOffset: -120, // 120 minutes before current time
            endOffset: 0    // 120 minutes after current time
          }
         },
         hrrr_location_2: { elements: ["precipcomposite","preciprate", "preciptype","temp", "feelslike", "dew", "humidity", "preciprate","windspeed", "winddir", "wind"], timeSkip: 60 ,
          loopWindow: {
            startOffset: 0,   // Current time
            endOffset: 7200  // 5 days (in minutes)
          }},
          iconeu_location_2: { elements: ["precipcomposite","preciprate", "preciptype", "temp", "feelslike", "dew", "humidity", "windspeed", "winddir", "wind"], timeSkip: 60 ,
          loopWindow: {
            startOffset: 0,   // Current time
            endOffset: 7200  // 5 days (in minutes)
          }},
         /*
          gfs_location: { elements: ["temp", "feelslike", "dew", "humidity", "precip"], timeSkip: 60 ,
          loopWindow: {
            startOffset: 0,   // Current time
            endOffset: 7200  // 5 days (in minutes)
          }},*/
          gfs_location_2: { elements: ["precipcomposite","preciprate", "preciptype", "temp", "feelslike", "dew", "humidity", "cloudcover","windspeed", "winddir", "wind"], timeSkip: 60 ,
          loopWindow: {
            startOffset: 0,   // Current time
            endOffset: 7200  // 5 days (in minutes)
          }},
          ecmwf_location_2: { elements: ["temp", "feelslike", "dew", "humidity", "preciprate", "cloudcover","windspeed", "winddir", "wind"], timeSkip: 60 ,
          loopWindow: {
            startOffset: 0,   // Current time
            endOffset: 7200  // 5 days (in minutes)
          }},
          ecmwfaifs_location_2: { elements: ["temp", "feelslike", "dew", "humidity", "preciprate", "cloudcover","windspeed", "winddir", "wind"], timeSkip: 60 ,
          loopWindow: {
            startOffset: 0,   // Current time
            endOffset: 7200  // 5 days (in minutes)
          }},
          weatherRadarSubhourly_location: { elements: ["reflectivity"], timeSkip: 10,
          loopWindow: {
            startOffset: -120, // 120 minutes before current time
            endOffset: 120    // 120 minutes after current time
          }
         },
          /*
          gfs13_location: { elements: ["temp", "feelslike", "dew", "humidity", "precip", "cloudcover"], timeSkip: 60 ,
          loopWindow: {
            startOffset: 0,   // Current time
            endOffset: 7200  // 5 days (in minutes)
          }},
          hybrid: { elements: ["temp", "feelslike", "dew", "humidity", "precip", "pop"], timeSkip: 60 ,
          loopWindow: {
            startOffset: 0,   // Current time
            endOffset: 7200  // 5 days (in minutes)
          }},
          hrrr_location: { elements: ["temp", "feelslike", "dew", "humidity", "precip"], timeSkip: 60 ,
          loopWindow: {
            startOffset: 0,   // Current time
            endOffset: 7200  // 5 days (in minutes)
          }},
          iconeu_location: { elements: ["temp", "feelslike", "dew", "humidity", "precip"], timeSkip: 60 ,
          loopWindow: {
            startOffset: 0,   // Current time
            endOffset: 7200  // 5 days (in minutes)
          }},
          gfes_location: { elements: ["pop"], timeSkip: 60 },
          */
        },
        selectedModel: "default",
        selectedElement: "preciprate",
        unitGroup: "metric",
        tileFormat: "webp",
        isPlaying: false,
        currentTime: null,
        timeSkip: 10,
        movieInterval: null,
        layerOpacity: 0.8,
        legendControl: null,
        baseApiUrl: "https://weather5.visualcrossing.com",//"http://localhost:8080", //
        weatherApiKey: "4UXQMWSDV5KEMM6JR2SC2FC8P",
        isFullScreenMap: true,
        playbackSpeed: 1.0,
        showDateTimePicker: false,
        mapReady: false,
        viewInfo: {
          lat: null,
          lng: null,
          zoom: null,
          centerPair: ''
        },
        modelTimeCache: {}, // remember per-model time
    };
  },
  computed: {
    formattedTime() {
      return this.currentTime ? this.formatFullDateTime(this.currentTime) : '';
    },
    availableElements() {
      return this.modelOptions[this.selectedModel].elements;
    },
    mapStyle() {
      return {
        height: 'calc(100vh - 110px)', // adjust if needed for controls height
        width: '100%',
      };
    },
    loopWindow() {
      const model = this.modelOptions[this.selectedModel];
      if (model && model.loopWindow) {
          const now = new Date();
          const start = new Date(now.getTime() + model.loopWindow.startOffset * 60 * 1000);
          const end = new Date(now.getTime() + model.loopWindow.endOffset * 60 * 1000);
          return { start, end };
      }
      return null;
    },
    dateTimeLocalValue() {
      if (!this.currentTime) return '';
      // Format as yyyy-MM-ddTHH:mm for input[type=datetime-local]
      const pad = n => String(n).padStart(2, '0');
      const y = this.currentTime.getUTCFullYear();
      const m = pad(this.currentTime.getUTCMonth() + 1);
      const d = pad(this.currentTime.getUTCDate());
      const h = pad(this.currentTime.getUTCHours());
      const min = pad(this.currentTime.getUTCMinutes());
      return `${y}-${m}-${d}T${h}:${min}`;
    },
  },
  watch: {
    // Ensure tiles refresh on all relevant option changes
    baseApiUrl() {
      if (!this.mapReady) return;
      this.refreshTiles(true);
    },
    tileFormat() {
      if (!this.mapReady) return;
      this.refreshTiles(true);
    },
    unitGroup() {
      if (!this.mapReady) return;
      this.refreshTiles();
      this.updateLegend();
    },
    selectedElement() {
      if (!this.mapReady) return;
      this.refreshTiles();
      this.updateLegend();
    }
  },
  mounted() {
    // Build map first
    this.initializeMap();
    this.mapReady = true;

    // Now align model/time after map exists
    this.onModelChange();

    this.addLegend();
    this.$nextTick(() => {
      this.updateMapSize();
      this.updateViewInfo(); // initialize info immediately
    });
  },
  methods: {
    // Ensure selectedElement is valid for selectedModel
    onTimeSkipOverride() {
      this.timeSkipOverride = true;
      this.currentTime = this.getLastInterval();
      this.updateLayer();
    },
    ensureValidSelectedElement() {
      const avail = this.availableElements;
      if (!avail || avail.length === 0) return;
      if (!avail.includes(this.selectedElement)) {
        this.selectedElement = avail[0];
      }
    },

    onModelChange() {
      // remember time for previous model
      if (this.selectedModel && this.currentTime) {
        this.modelTimeCache[this.selectedModel] = new Date(this.currentTime);
      }

      // Update timeSkip from model config
      const cfg = this.modelOptions[this.selectedModel] || this.modelOptions.default;
      if (!this.timeSkipOverride) {
        this.timeSkip = (cfg && cfg.timeSkip) ? cfg.timeSkip : 10;
      }

      // Ensure element is valid for the model
      this.ensureValidSelectedElement();

      // restore remembered time for this model, or align to interval
      const cached = this.modelTimeCache[this.selectedModel];
      this.currentTime = cached ? new Date(cached) : this.getLastInterval();

      // Refresh tiles and legend
      if (this.mapReady) {
        this.refreshTiles(true);
        this.updateLegend();
      }
    },

    // Helper to force-refresh tiles
    refreshTiles(force = false) {
      // If tile layer exists, update URL and force redraw
      this.updateLayer(force);
    },

    updateViewInfo() {
      if (!this.map) return;
      const c = this.map.getCenter();
      const lat = Number(c.lat.toFixed(5));
      const lng = Number(c.lng.toFixed(5));
      const zoom = this.map.getZoom();
      this.viewInfo.lat = lat;
      this.viewInfo.lng = lng;
      this.viewInfo.zoom = zoom;
      this.viewInfo.centerPair = `${lat},${lng}`;
    },

    async copyCenterToClipboard() {
      const text = this.viewInfo.centerPair || '';
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          const ta = document.createElement('textarea');
          ta.value = text;
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
      } catch (e) {
        console.warn('Copy failed', e);
      }
    },

    initializeMap() {
      this.map = L.map("map").setView([0, 0], 7);
      
      this.baseLayer = L.tileLayer("https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png", {
        subdomains: "abcd",
        maxZoom: 19,
        attribution: "&copy; <a href='https://carto.com'>CARTO</a>",
      }).addTo(this.map);
      
     /*
     this.baseLayer = L.tileLayer(" https://osm2.visualcrossing.com/osm/{z}/{x}/{y}.png", {
        subdomains: "abcd",
        maxZoom: 19,
        attribution: "&copy; <a href='https://visualcrossing.com'>Visual Crossing</a>",
      }).addTo(this.map);
      */
      /*
      this.labelLayer = L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}{r}.png", {
        subdomains: "abcd",
        maxZoom: 19,
        attribution: "&copy; <a href='https://carto.com'>CARTO</a>",
      }).addTo(this.map);
      */
      this.map.on("zoomstart", () => { this.isZooming = true; });
      this.map.on("zoomend", () => {
        this.isZooming = false;
        if (this.labelLayer) this.labelLayer.bringToFront();
        this.updateViewInfo();
      });
      this.map.on("moveend", this.updateViewInfo);

      // Initial tiles
      this.updateLayer(true);

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            this.map.setView([latitude, longitude], 10);
            // moveend will fire and update info
          },
          (error) => {
            console.error("Geolocation error:", error);
          }
        );
      }

      //this.map.on('click', this.onMapClick);

      // Initialize info now as well
      this.updateViewInfo();
    },

    updateLayer(force = false) {
      if (!this.map) return;          // guard
      if (!this.currentTime) return;

      const resolvedModelIdParam =
        this.selectedModel && this.selectedModel !== 'default'
          ? `&source=${this.selectedModel}`
          : '';
      //http://localhost:8080/VisualCrossingWebServices/rest/api/v1/map/tile/preciprate/0/0/0.webp?key=4UXQMWSDV5KEMM6JR2SC2FC8P&time=2025-11-25T12:43:00
      /*
      const tileUrl =
        `${this.baseApiUrl}/VisualCrossingWebServices/rest/services/retrievetile/` +
        `${this.selectedElement}/{z}/{x}/{y}/${this.formatDateTime(this.currentTime)}` +
        `?key=${this.weatherApiKey}` +
        `&altitude=0&refresh=true&nocache=${Date.now()}` +
        `&format=${this.tileFormat}&unitGroup=${this.unitGroup}` +
        `${resolvedModelIdParam}`;
      */
      const tileUrl =
        `${this.baseApiUrl}/VisualCrossingWebServices/rest/api/v1/map/tile/` +
        `${this.selectedElement}/{z}/{x}/{y}.${this.tileFormat}` +
        `?key=${this.weatherApiKey}` +
        `&time=${this.formatFullDateTime(this.currentTime)}` +
        `&unitGroup=${this.unitGroup}` +
        `${resolvedModelIdParam}`;

      if (!this.tileLayer || force) {
        // Recreate layer when forcing (server/format/model change)
        if (this.tileLayer) {
          this.map.removeLayer(this.tileLayer);
        }
        this.tileLayer = L.tileLayer(tileUrl, {
          tileSize: 256,
          maxZoom: 18,
          opacity: this.layerOpacity,
          attribution: "&copy; <a href='https://www.visualcrossing.com'>Visual Crossing</a>",
          updateWhenZooming: true,
          updateWhenIdle: true
        }).addTo(this.map);
      } else {
        // Normal updates: change URL and redraw
        this.tileLayer.setUrl(tileUrl);
        this.tileLayer.setOpacity(this.layerOpacity);
        // Force re-request in case Leaflet optimizes away
        if (this.tileLayer.redraw) this.tileLayer.redraw();
      }

      if (this.labelLayer) this.labelLayer.bringToFront();
      if (!this.isPlaying) this.updateLegend();
    },

    removeLayer(newLayer, previousLayer, map, fadeDuration = 250) {
          if (!map) return;

          // Gradually decrease the opacity
          let opacity = this.layerOpacity;
          const step = 50 / fadeDuration;

          const fadeInterval = setInterval(() => {
              opacity -= step;
              if (newLayer) newLayer.setOpacity(this.layerOpacity-opacity);
              if (opacity <= 0) {
                  clearInterval(fadeInterval);
                  // Once faded, remove the layer
                  if (newLayer) newLayer.setOpacity(this.layerOpacity);
                  if (previousLayer) map.removeLayer(previousLayer);
              } else {
                if (previousLayer) previousLayer.setOpacity(opacity);
              }
          }, 50);
      },
      addLegend() {
        if (!this.map) return;
        this.legendControl = L.control({ position: 'bottomright' });
  
        this.legendControl.onAdd = () => {
          const div = L.DomUtil.create('div', 'legend');
          div.style.backgroundColor = 'white';
          div.style.padding = '8px';
          div.style.borderRadius = '4px';
          div.style.boxShadow = '0 0 15px rgba(0, 0, 0, 0.2)';
          this.updateLegendContent(div);
          return div;
        };
  
        this.legendControl.addTo(this.map);
      },
      async updateLegend() {
        if (this.legendControl) {
          const container = this.legendControl.getContainer();
          if (container) {
            const div = L.DomUtil.create('div', 'legend');
            await this.updateLegendContent(div);
            container.innerHTML = div.innerHTML;
          }
        }
      },
      async updateLegendContent(div) {
        /*
        const legendUrl = `${this.baseApiUrl}/VisualCrossingWebServices/rest/services/tilebins/${this.selectedElement}?key=${this.weatherApiKey}&unitGroup=${this.unitGroup}`;
        */
        const legendUrl = `${this.baseApiUrl}/VisualCrossingWebServices/rest/api/v1/map/legend/${this.selectedElement}` +
          `?key=${this.weatherApiKey}` +
          `&unitGroup=${this.unitGroup}`;
        try {
          const response = await fetch(legendUrl);
          const raw = await response.json();
          // Support either: [ {color,min,max}, ... ] OR [ [ {color,min,...}, ... ], [ ... ] ]
          const groups = (Array.isArray(raw) && raw.length && Array.isArray(raw[0])) ? raw : [raw];
          div.innerHTML = '<strong>Legend</strong>';
          groups.forEach((group, gIdx) => {
            if (!Array.isArray(group)) return;
            const labelInterval = Math.max(1, Math.ceil(group.length / 10));
            //if (groups.length > 1) {
            //  div.innerHTML += `<div style="margin:4px 0 2px;font-size:11px;font-weight:600;">Group ${gIdx + 1}</div>`;
           // }
            group.forEach((bin, index) => {
              if (!bin || !bin.color) return;
              div.innerHTML += `
                <div style="display:inline-block;text-align:center;margin-right:5px;vertical-align:top;">
                  <div style="background-color:${bin.color};width:20px;height:20px;"></div>
                  ${index % labelInterval === 0 ? `<span>${bin.min ?? ''}</span>` : ''}
                </div>`;
            });
          });
        } catch (error) {
          div.innerHTML = '<strong>Legend</strong><br><span>Error loading legend</span>';
          console.error("Error loading legend data:", error);
        }
      },
      updateMapSize() {
        if (this.map) {
          this.map.invalidateSize();
        }
      },
      async onMapClick(e) {
        const { lat, lng } = e.latlng;
        await this.fetchWeatherData(lat.toFixed(3), lng.toFixed(3));
      },
      async fetchWeatherData(lat, lng) {
        const weatherApiUrl = `${this.baseApiUrl}/VisualCrossingWebServices/rest/services/timeline/${lat},${lng}/yesterday/next5days?key=${this.weatherApiKey}&unitGroup=${this.unitGroup}&include=current`;
  
        try {
          const response = await fetch(weatherApiUrl);
          const data = await response.json();
  
          const elementValue = data.currentConditions ? data.currentConditions[this.selectedElement] : 'Unavailable';
  
          const headerRow = `<tr><th>Date</th><th>Min Temp</th><th>Max Temp</th><th>Precip Prob</th></tr>`;
          const daysData = data.days.map(day => 
            `<tr><td>${day.datetime}</td><td>${day.tempmin}${this.unitGroup === 'us' ? '°F' : '°C'}</td><td>${day.tempmax}${this.unitGroup === 'us' ? '°F' : '°C'}</td><td>${day.precipprob}%</td></tr>`
          ).join('');
  
          L.popup()
            .setLatLng([lat, lng])
            .setContent(`Lat,Lon: ${lat},${lng}<br>DateTime: ${this.formattedTime}<br>${this.selectedElement}: ${elementValue}<br>
              <table border="1" style="width: 100%;">
                ${headerRow}
                ${daysData}
              </table>`)
            .openOn(this.map);
  
        } catch (error) {
          console.error("Error fetching weather data:", error);
          L.popup()
            .setLatLng([lat, lng])
            .setContent(`Lat,Lon: ${lat},${lng}<br>Error fetching data`)
            .openOn(this.map);
        }
      },
      formatFullDateTime(date) {
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const day = String(date.getUTCDate()).padStart(2, "0");
        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        const seconds = "00";
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
      },
      formatDateTime(date) {
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const day = String(date.getUTCDate()).padStart(2, "0");
        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        return `${year}${month}${day}${hours}${minutes}`;
      },
      getLastInterval() {
        const now = new Date();
        const selectedModelConfig = this.modelOptions[this.selectedModel] || this.modelOptions["weatherRadarSubhourly_location"];
        const timeSkip = this.timeSkip ?? selectedModelConfig.timeSkip;
  
        if (timeSkip === 60) {
          now.setUTCMinutes(0, 0, 0);
        } else {
          const intervalMinutes = Math.floor(now.getUTCMinutes() / timeSkip) * timeSkip - timeSkip;
          now.setUTCMinutes(intervalMinutes, 0, 0);
        }
  
        return now;
      },
      setDateTime(date) {
        if (!(date instanceof Date)) {
          console.error("setDateTime expects a Date object");
          return;
        }
        this.currentTime = new Date(date);
        if (this.selectedModel) {
          this.modelTimeCache[this.selectedModel] = new Date(this.currentTime);
        }
        this.updateLayer();
      },
      updateLayerOpacity() {
        if (this.tileLayer) {
          this.tileLayer.setOpacity(this.layerOpacity);
        }
      },
      toggleMoviePlay() {
        if (this.isPlaying) {
          this.stopMovie();
        } else {
          this.startMovie();
        }
      },
      startMovie() {
        this.isPlaying = true;
        this.movieInterval = setInterval(() => {
          this.incrementTime();
          this.updateLayer();
        }, 1000/this.playbackSpeed);
      },
      stopMovie() {
        this.isPlaying = false;
        clearInterval(this.movieInterval);
      },
      incrementTime() {
        if (!this.currentTime) return;
        this.currentTime = this.calculateNewTime(this.timeSkip);
        // update cache
        if (this.selectedModel) {
          this.modelTimeCache[this.selectedModel] = new Date(this.currentTime);
        }
        if (this.isPlaying && this.loopWindow) {
            if (this.currentTime.getTime() > this.loopWindow.end.getTime()) {
                this.currentTime = this.loopWindow.start;
                if (this.selectedModel) {
                  this.modelTimeCache[this.selectedModel] = new Date(this.currentTime);
                }
            }
        }
        this.updateLayer();
      },
      decrementTime() {
        if (!this.currentTime) return;
        this.currentTime = this.calculateNewTime(-this.timeSkip);
        // update cache
        if (this.selectedModel) {
          this.modelTimeCache[this.selectedModel] = new Date(this.currentTime);
        }
        this.updateLayer();
      },
      calculateNewTime(timeDelta) {
        if (!this.currentTime) return this.getLastInterval();
        const date = new Date(this.currentTime);
        date.setUTCMinutes(date.getUTCMinutes() + timeDelta);
        return date;
      },
      resetToInitialTime() {
        this.currentTime =this.getLastInterval();
        // update cache
        if (this.selectedModel) {
          this.modelTimeCache[this.selectedModel] = new Date(this.currentTime);
        }
        this.updateLayer();
      },
      onDateTimeInput(e) {
        const val = e.target.value;
        if (val) {
          // Parse as UTC
          const date = new Date(val + ':00Z');
          this.setDateTime(date);
        }
        this.showDateTimePicker = false;
      },
    },
  };
  </script>
  
  <style>
  #map {
    width: 100%;
  }
  .time-overlay {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(255, 255, 255, 0.8);
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: bold;
    z-index: 1000;
  }
  .controls {
    margin: 10px 0;
  }
  .controls label {
    margin-right: 10px;
  }
  .controls select,
  .controls input {
    margin-right: 20px;
  }
  .legend {
    background-color: white;
    padding: 8px;
    border-radius: 4px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .datetime-picker-overlay {
    position: absolute;
    top: 10px;
    right: 10px;
    background: white;
    border: 1px solid #ccc;
    padding: 10px 15px;
    border-radius: 6px;
    z-index: 2000;
    box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  }
  .info {
    margin: 6px 0 10px 0;
    font-family: system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
    font-size: 14px;
    line-height: 1.35;
    display: flex;
    gap: 20px;
    justify-content: flex-start;
    align-items: center;
  }
  .info code {
    background: #f6f8fa;
    padding: 1px 6px;
    border-radius: 4px;
    user-select: all;
  }
  </style>